import React from 'react';
import { useSidebar } from './SidebarContext';

export default function Topbar({ title, actions }) {
  const { toggle } = useSidebar();
  return (
    <div className="topbar">
      <div className="d-flex align-items-center gap-2">
        <button className="topbar-menu-btn d-md-none" onClick={toggle} aria-label="Ouvrir le menu">
          <i className="bi bi-list"></i>
        </button>
        <h1 className="topbar-title">{title}</h1>
      </div>
      {actions && <div className="d-flex gap-2">{actions}</div>}
    </div>
  );
}
